import React from 'react';
import { motion } from 'framer-motion';
type RevealProps = {
  children: React.ReactNode;
  delay?: number;
  className?: string;
};
export function Reveal({
  children,
  delay = 0,
  className = ''
}: RevealProps) {
  return <motion.div className={className} initial={{
    opacity: 0,
    y: 12
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.25
  }} transition={{
    duration: 0.3,
    delay,
    ease: [0.23, 1, 0.32, 1]
  }} data-id="element-203" data-mp="3bixe8dvtm5pf">
      {children}
    </motion.div>;
}